// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts"
// @generated from file penumbra/core/component/governance/v1/governance.proto (package penumbra.core.component.governance.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { AllTalliedDelegatorVotesForProposalRequest, AllTalliedDelegatorVotesForProposalResponse, NextProposalIdRequest, NextProposalIdResponse, ProposalDataRequest, ProposalDataResponse, ProposalInfoRequest, ProposalInfoResponse, ProposalListRequest, ProposalListResponse, ProposalRateDataRequest, ProposalRateDataResponse, ValidatorVotesRequest, ValidatorVotesResponse, VotingPowerAtProposalStartRequest, VotingPowerAtProposalStartResponse } from "./governance_pb.js";
import { MethodKind } from "@bufbuild/protobuf";
/**
 * Query operations for the governance component.
 *
 * @generated from service penumbra.core.component.governance.v1.QueryService
 */
export const QueryService = {
    typeName: "penumbra.core.component.governance.v1.QueryService",
    methods: {
        /**
         * @generated from rpc penumbra.core.component.governance.v1.QueryService.ProposalInfo
         */
        proposalInfo: {
            name: "ProposalInfo",
            I: ProposalInfoRequest,
            O: ProposalInfoResponse,
            kind: MethodKind.Unary,
        },
        /**
         * @generated from rpc penumbra.core.component.governance.v1.QueryService.ProposalList
         */
        proposalList: {
            name: "ProposalList",
            I: ProposalListRequest,
            O: ProposalListResponse,
            kind: MethodKind.ServerStreaming,
        },
        /**
         * @generated from rpc penumbra.core.component.governance.v1.QueryService.ProposalData
         */
        proposalData: {
            name: "ProposalData",
            I: ProposalDataRequest,
            O: ProposalDataResponse,
            kind: MethodKind.Unary,
        },
        /**
         * @generated from rpc penumbra.core.component.governance.v1.QueryService.NextProposalId
         */
        nextProposalId: {
            name: "NextProposalId",
            I: NextProposalIdRequest,
            O: NextProposalIdResponse,
            kind: MethodKind.Unary,
        },
        /**
         * @generated from rpc penumbra.core.component.governance.v1.QueryService.ValidatorVotes
         */
        validatorVotes: {
            name: "ValidatorVotes",
            I: ValidatorVotesRequest,
            O: ValidatorVotesResponse,
            kind: MethodKind.ServerStreaming,
        },
        /**
         * @generated from rpc penumbra.core.component.governance.v1.QueryService.VotingPowerAtProposalStart
         */
        votingPowerAtProposalStart: {
            name: "VotingPowerAtProposalStart",
            I: VotingPowerAtProposalStartRequest,
            O: VotingPowerAtProposalStartResponse,
            kind: MethodKind.Unary,
        },
        /**
         * @generated from rpc penumbra.core.component.governance.v1.QueryService.AllTalliedDelegatorVotesForProposal
         */
        allTalliedDelegatorVotesForProposal: {
            name: "AllTalliedDelegatorVotesForProposal",
            I: AllTalliedDelegatorVotesForProposalRequest,
            O: AllTalliedDelegatorVotesForProposalResponse,
            kind: MethodKind.ServerStreaming,
        },
        /**
         * Used for computing voting power ?
         *
         * @generated from rpc penumbra.core.component.governance.v1.QueryService.ProposalRateData
         */
        proposalRateData: {
            name: "ProposalRateData",
            I: ProposalRateDataRequest,
            O: ProposalRateDataResponse,
            kind: MethodKind.ServerStreaming,
        },
    }
};
